import React, { useEffect, useState } from "react";
import TableContainer from "../../../../Component/TableContainer";
import { Box, Checkbox, IconButton, Switch, Typography } from "@mui/material";
import { Link, useSearchParams,useNavigate } from "react-router-dom";
import { masterAPI } from "../../../Masters/dataConfig";
import { axiosPrivate } from "../../../../axios/axios";
import {
  ArrowBack,
  CheckCircle,
  DeleteOutline,
  EditOffOutlined,
  EditOutlined,
  RadioButtonUncheckedOutlined,
} from "@mui/icons-material";
import { color } from "../../../../StyleData/Config";
import CreateAssetCategory from "./StockRoomRowBinsModal";
import StockRoomRowModal from "./StockRoomRowBinsModal";
import { useSelector } from "react-redux"
import { decode, encode } from "../../../../Component/JWT/Formatt";

import ResponsiveDialog from "../../../../Component/ResponsiveDialog";
const StockRoomRowBins = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate=useNavigate()
  const aisleId=useSelector(state=>state.dataRed.aisle)
  const aisleCode=useSelector(state=>state.dataRed.aisleCode)
  const aisleName=useSelector(state=>state.dataRed.aisleName)
  console.log("check",aisleCode)
  const actionsAllow=useSelector(state=>state.dataRed.actionsAllow)

  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [create, setCreate] = useState(false);
  const [mode, setMode] = useState("");
  const [editData, setEditData] = useState({});
  const [filterValue, setFilterValue] = useState("enableData");
  const [backUpData, setBackUpData] = useState([]);
  const code = searchParams.get("code")
  const name = searchParams.get("name")
  useEffect(() => {
    getData();
  }, []);

  const getData = async() => {
    setIsLoading(true);
    const link = masterAPI["stockRoomRowBin"].link;
    const id=decode(searchParams.get("id"))
   await axiosPrivate
      .get(`${link}/${id}`)
      .then((res) => {
        res.data.result.sort((a, b) => {
          return a.code.localeCompare(b.code, undefined, {
            numeric: true,
            sensitivity: 'base'
          });
        });
        if (filterValue === "enableData") {
          const filterDataResult = res.data.result.filter(
            (fil) => fil.isActive
          );
          console.log(filterDataResult, "filterData");
          setData(filterDataResult);
          setBackUpData(res.data.result);
        } else {
          setData(res.data.result);
          setBackUpData(res.data.result);
        }
        setIsLoading(false);
      })
      .catch((e) => {
        console.log(e, "stockRoomRowBin");
        setIsLoading(false);
        setData([])
        setBackUpData([])
      });
  };

  const handleButtonNew = () => {
    setMode("Create");
    setCreate(true);
  };
  const handleCreateClose = () => {
    setMode("");
    setCreate(false);
    getData();
  };

  const handleEdit = (data) => {
    setEditData(data);
    setMode("Edit");
    setCreate(true);
  };

  // const handleDelete = (id) => {
  //   const deleteLink = masterAPI["stockRoomRowBin"].delete;
  //   axiosPrivate
  //     .delete(`${deleteLink}/${id}`)
  //     .then((res) => {
  //       console.log(res.data);
  //       getData();
  //     })
  //     .catch((e) => {
  //       console.log(e, "delete stockRoomRowBin");
  //     });
  // };

  const handleDelete = async(e, id) => {
    const enableLink = masterAPI["stockRoomRowBin"].enable;
    const disableLink = masterAPI["stockRoomRowBin"].disable;
    if (e.target.checked) {
     await axiosPrivate
        .put(`${enableLink}/${id}`)
        .then((res) => {
          console.log(res.data);
          getData();
        })
        .catch((e) => {
          console.log(e, "enable stockroomrowbin");
        });
    } else {
     await axiosPrivate
        .put(`${disableLink}/${id}`)
        .then((res) => {
          console.log(res.data);
          getData();
        })
        .catch((e) => {
          console.log(e, "disable stockroomrowbin");
        });
    }
  };

  const columns = [
    {
      accessor: "id",
      disableFilters: true,
      Cell: () => {
        return (
          <Box sx={{ width: color.checkBoxWidth }}>
            <Checkbox
              // icon={<RadioButtonUncheckedOutlined />}
              // checkedIcon={<CheckCircle />}
            />
          </Box>
        );
      },
    },
    {
      Header: "Bin Code",
      accessor: "code",
      // Cell: ({ cell }) => {
      //   return (
      //     <Link
      //       to={`/stockroomrowbins?id=${cell.row.original.id}`}
      //       style={{
      //         color: "#0d6efd",
      //         textDecorationLine: "underline",
      //         fontWeight: 800,
      //       }}
      //     >
      //       {cell.value}
      //     </Link>
      //   );
      // },
      // disableFilters: true,
    },
    {
      Header: "Bin Name",
      accessor: "binName",
      // disableFilters: true,
    },
    {
      Header: "Stock Room Row",
      accessor: "rowName",
    },
    {
      Header: "Actions",
      Cell: ({ cell }) => {
        // console.log(cell)
        return (
          <Box sx={{ whiteSpace: "nowrap" }}>
            <IconButton
             disabled={!actionsAllow.edit}
              onClick={() => {
                handleEdit(cell.row.original);
              }}
            >
              <EditOutlined
                sx={{
                  fontSize: color.masterEditDelButton,
                  color:actionsAllow.edit? color.masterEditDelButtonColor:"default",
                }}
              />
            </IconButton>
            {/* <IconButton
             disabled={!actionsAllow.delete}
              onClick={() => {
                handleDelete(cell.row.original.id);
              }}
            >
              <DeleteOutline
                sx={{
                  fontSize: color.masterEditDelButton,
                  color:actionsAllow.delete? color.masterEditDelButtonColor:"default",
                }}
              />
            </IconButton> */}
            <Switch
              disabled={!actionsAllow.delete}
              checked={cell.row.original.isActive}
              onChange={(e) => {
                handleDelete(e, cell.row.original.id);
              }}
            />
          </Box>
        );
      },
    },
  ];

  const handleChangeFilter = (e) => {
    if (e === "showAll") {
      setData(backUpData);
    } else {
      const filterDataResult = backUpData.filter((fil) => fil.isActive);

      setData(filterDataResult);
    }
    setFilterValue(e);
  };

  return (
    <>
      <Box sx={{display:"flex",alignItems:"center"}}>
        <IconButton onClick={()=>{navigate(`/stockroomrow?id=${encode(aisleId)}&code=${aisleCode}&name=${aisleName}`)}}>
          <ArrowBack/>
        </IconButton>
        <Typography
          sx={{
            color: color.masterPageTitleColor,
            fontSize: color.masterPageTitleFontSize,
            fontWeight: color.masterPageTitleFontWeight,
            // mb: color.masterPageTitlemd,
          }}
        >
          { masterAPI["stockRoomRowBin"].title} - {code} - {name}
        </Typography>
      </Box>

      <TableContainer
        columns={columns}
        data={data}
        buttonNew={handleButtonNew}
        loading={isLoading}
        buttonDisable={!actionsAllow.edit}
        filterValue={filterValue}
        handleChange={handleChangeFilter}
        filterShow={true}
      />

      <ResponsiveDialog
        open={create}
        onClose={handleCreateClose}
        maxWidth={"md"}
        children={
          <StockRoomRowModal
            handleCloseClick={handleCreateClose}
            mode={mode}
            editData={editData}
          />
        }
      />
    </>
  );
};

export default StockRoomRowBins;
